import React from 'react';
import Btn, { ButtonRefType } from '../Btn';
import { BtnModifier } from '../Btn';
import { SVGIcon } from '../../../atoms/SVG';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

type ButtonRoundSpecificProps = {
  text?: string;
  icon?: SVGIcon;
  active?: boolean;
  disabledLink?: boolean;
  type?: 'button' | 'submit' | 'reset';
  focusOnMount?: boolean;
  reference?: ButtonRefType;
  href?: string;
  routing?: boolean;
  rel?: string;
  tooltipPlacement?: TooltipPlacement;
  children?: React.ReactNode;
};

export type ButtonRoundProps = SharedButtonProps & ButtonRoundSpecificProps;

export function ButtonRound({
  text,
  icon,
  active = false,
  disabledLink = false,
  type = 'button',
  focusOnMount,
  reference,
  href,
  routing,
  rel,
  tooltipPlacement,
  ariaCurrent,
  onClick,
  onKeyDown,
  onKeyUp,
  children,
  ...rest
}: ButtonRoundProps) {
  const modifier = active ? [BtnModifier.ROUND, BtnModifier.ACTIVE] : [BtnModifier.ROUND];

  return (
    <Btn
      {...rest}
      modifier={modifier}
      text={text}
      svgSpriteId={icon}
      hiddenText={icon !== undefined}
      disabledLink={disabledLink}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      ariaCurrent={ariaCurrent}
      type={type}
      titleText={icon !== undefined ? text : undefined}
      focusOnMount={focusOnMount}
      reference={reference}
      href={href}
      routing={routing}
      rel={rel}
      tooltipPlacement={tooltipPlacement}
    >
      {children}
    </Btn>
  );
}
